import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {ListItemIcon, ListItemText, Tooltip} from "@mui/material";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import Divider from "@mui/material/Divider";
import {Link} from "react-router-dom";
import ExternalDataIcon from "../ImagesAndIcons/ExternalDataIcon";
import React from "react";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Box from "@mui/material/Box";


export default function AppMenuBarMenu({ setIsAuthenticated,  hideActions}) {

    const [mainAnchorEl, setMainAnchorEl] = React.useState(null);
    const isMainMenuOpen = Boolean(mainAnchorEl);

    const handleMainMenuClose = () => {
        setMainAnchorEl(null);
    };

    const handleMainMenuOpen = (event) => {
        setMainAnchorEl(event.currentTarget);
    };


    const mainMenuId = 'main-menu';


 return(
     <Box>
         <Tooltip  enterDelay={1000}  title={"Tables"}>
     <IconButton
         size="large"
         edge="start"
         color="inherit"
         aria-label="open main menu"
         aria-controls={mainMenuId}
         aria-haspopup="true"
         sx={{ mr: 2 }}
         onClick={handleMainMenuOpen}
     >
         <MenuIcon />
     </IconButton>
         </Tooltip>
        <Menu
            anchorEl={mainAnchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            id={mainMenuId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            open={isMainMenuOpen}
            onClose={handleMainMenuClose}
            aria-label="table navigation"
            aria-controls="main-menu"
            aria-haspopup="true"
        >
            <Tooltip enterDelay={1000} title={"Internal Data is the world of contracts."}>
            <MenuItem onClick={handleMainMenuClose}>
                <ListItemIcon>
                    <Brightness1Icon fontSize="small"/>
                </ListItemIcon>

                <ListItemText>Internal Data</ListItemText>

            </MenuItem>
            </Tooltip>
            <Divider/>

            <MenuItem
                component={Link} to={"/DataPoints"}
                onClick={() => {
                    handleMainMenuClose();
                }}>Data Points</MenuItem>

            <MenuItem
                component={Link} to={"/DataPointValues"}
                onClick={() => {
                    handleMainMenuClose();
                }}>Data Point Values</MenuItem>

            <MenuItem
                component={Link} to={"/DataPointAttributes"}
                onClick={() => {
                    handleMainMenuClose();
                }}>Data Point Attributes</MenuItem>

            <MenuItem
                component={Link} to={"/DataPointXrefs"}
                onClick={() => {
                    handleMainMenuClose();
                }}>Data Point Xrefs</MenuItem>

            <Divider/>
            <Tooltip enterDelay={1000} title={"External Data is real world data, outside of contracts."}>
            <MenuItem
                onClick={handleMainMenuClose}>
                <ListItemIcon>
                    <ExternalDataIcon fontSize="small"/>
                </ListItemIcon>
                <ListItemText>External Data</ListItemText>
            </MenuItem>
            </Tooltip>
            <Divider/>


            <MenuItem
                component={Link} to={"/ExternalData/Exchange"}
                onClick={() => {
                    handleMainMenuClose();
                }}>Exchange Rates</MenuItem>
            <MenuItem
                component={Link} to={"/ExternalData/Financials"}
                onClick={() => {
                    handleMainMenuClose();
                }}>Financials</MenuItem>
            <MenuItem
                component={Link} to={"/ExternalData/Interest"}
                onClick={() => {
                    handleMainMenuClose();
                }}>Interest Rates</MenuItem>
            <MenuItem
                component={Link} to={"/ExternalData/Licenses"}
                onClick={() => {
                    handleMainMenuClose();
                }}>Licenses</MenuItem>

            <MenuItem
                component={Link} to={"/ExternalData/Platforms"}
                onClick={() => {
                    handleMainMenuClose();
                }}>Platforms</MenuItem>

            <MenuItem
                component={Link} to={"/ExternalData/Products"}
                onClick={() => {
                    handleMainMenuClose();
                }}>Products</MenuItem>

            <MenuItem
                component={Link} to={"/ExternalData/Profiles"}
                onClick={() => {
                    handleMainMenuClose();
                }}
            >Profiles</MenuItem>

            <MenuItem
                component={Link} to={"/ExternalData/StakeholderLists"}
                onClick={() => {
                    handleMainMenuClose();
                }}>Stakeholder Lists</MenuItem>

            <MenuItem
                component={Link} to={"/ExternalData/Subscribers"}
                onClick={() => {
                    handleMainMenuClose();
                }}>Subscribers</MenuItem>

            <MenuItem
                component={Link} to={"/ExternalData/Usage"}
                onClick={() => {
                    handleMainMenuClose();
                }}>Usage</MenuItem>
            <MenuItem
                component={Link} to={"/ExternalData/Viewership"}
                onClick={() => {
                    handleMainMenuClose();
                }}>Viewership</MenuItem>

        </Menu>

     </Box>
    );

}